"use strict";
/**
 * When [[DelegationNode]]s or [[DelegationRootNode]]s are written on the blockchain, they're encoded.
 * DelegationDecoder helps to decode them when they're queried from the chain.
 *
 * The DelegationDecoder methods transform a Codec type into an object of a KILT type.
 *
 * @packageDocumentation
 * @module DelegationDecoder
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeDelegationNode = exports.decodeRootDelegation = void 0;
/**
 * Dummy comment needed for correct doc display, do not remove.
 */
const types_1 = require("@kiltprotocol/types");
const utils_1 = require("@kiltprotocol/utils");
function decodeRootDelegation(encoded) {
    utils_1.DecoderUtils.assertCodecIsType(encoded, ['Option<DelegationRoot>']);
    if (encoded.isSome) {
        const delegationRoot = encoded.unwrap();
        // TODO: check that root is none
        return {
            cTypeHash: delegationRoot.ctypeHash.toString(),
            account: delegationRoot.owner.toString(),
            revoked: delegationRoot.revoked.valueOf(),
        };
    }
    return null;
}
exports.decodeRootDelegation = decodeRootDelegation;
/**
 * Decode the permissions from the bitset encoded in the given `number`.
 * We use bitwise `AND` to check if a permission bit flag is set.
 *
 * @param bitset The u32 number used as the bitset to encode permissions.
 * @returns The permission set.
 */
function decodePermissions(bitset) {
    const permissions = [];
    // eslint-disable-next-line no-bitwise
    if (bitset & types_1.Permission.ATTEST) {
        permissions.push(types_1.Permission.ATTEST);
    }
    // eslint-disable-next-line no-bitwise
    if (bitset & types_1.Permission.DELEGATE) {
        permissions.push(types_1.Permission.DELEGATE);
    }
    return permissions;
}
function decodeDelegationNode(encoded) {
    utils_1.DecoderUtils.assertCodecIsType(encoded, ['Option<DelegationNode>']);
    if (encoded.isSome) {
        const delegationNode = encoded.unwrap();
        return {
            rootId: delegationNode.rootId.toString(),
            parentId: delegationNode.parent.isSome
                ? delegationNode.parent.toString()
                : undefined,
            account: delegationNode.owner.toString(),
            permissions: decodePermissions(delegationNode.permissions.toNumber()),
            revoked: delegationNode.revoked.valueOf(),
        };
    }
    return null;
}
exports.decodeDelegationNode = decodeDelegationNode;
